import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddIcon from "@mui/icons-material/Add";
import AddSmothiee from "../../Modals/addProduct";
import AddBoxArt from "../../Modals/addBoxArt";

const ManageBoxArt = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const [rows] = useState([
    {
      id: 1,
      name: "Wild Berries",
      createdDate: "01-Sept-2025",
      status: true,
    },
    {
      id: 2,
      name: "Bees",
      createdDate: "01-Sept-2025",
      status: true,
    },
    {
      id: 3,
      name: "Lavender",
      createdDate: "01-Sept-2025",
      status: true,
    }
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Manage Box Art</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Box Art
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => setOpenModal(true)}
            >
              <AddIcon /> Add Box Art
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Box Art Name</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => (
                <TableRow hover key={row.id}>
                  <TableCell>
                    <div className="user_block no_radius">
                      <figure>
                        <img src="/static/images/placeholder.png" alt="User" />
                      </figure>
                      <p><b>{row.name}</b></p>
                    </div>
                  </TableCell>
                  <TableCell>{row.createdDate}</TableCell>
                  <TableCell>
                    <SwitchToggle />
                  </TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <AddBoxArt
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageBoxArt;
